import { createI18n } from 'vue-i18n'
import En from '../../lang/en.json'
import Es from '../../lang/es.json'

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        'en' : { ...En },
        'es': { ...Es }
    }
})

export async function setLocale(locale) {
    // If locale already loaded, just switch
    if (!i18n.global.availableLocales.includes(locale)) {
        try {
            const messages = await import(`./locales/${locale}.json`);
            i18n.global.setLocaleMessage(locale, messages.default);
        } catch (err) {
            console.warn(`Locale ${locale} not found, falling back to English`);
            locale = 'en';
        }
    }
    i18n.global.locale = locale; // set current locale
}

export default i18n;
